// 获取开门列表
const getOpenDoorList = `/gateway/hc-serve/miniapi/reservation/getOpenDoorList`;
//开门
const openDoorUrl = `/gateway/hc-serve/miniapi/reservation/openDoor`;
export {
  getOpenDoorList,
  openDoorUrl
};
